app.service('exportService', ['crudService', '$window', '$q', '$filter', 'modalService', function (crudService, $window, $q, $filter, modalService) {
    return {
        download: function (format, template, cols, rows, extras) {
            //TODO erreur si format non valide

            return crudService.post(
                '/' + format + '/export',
                {
                    'template': template,
                    'colonnes': cols,
                    'lignes': rows,
                    'extras': extras || {}
                }
            ).then(function (response) {
                $window.location.href = '/' + format + '/download/' + response;
            });
        },
        excel: function (template, cols, rows, extras) {
            return this.download('excel', template, cols, rows, extras);
        },
        csv: function (template, cols, rows, extras) {
            return this.download('csv', template, cols, rows, extras);
        },
        pdf: function (template, cols, rows, extras) {
            return this.download('pdf', template, cols, rows, extras);
        },

        /**
         * Nouvelle version pour l'export UI-GRID si moins de 2000 lignes
         * @param  {[type]} grid_name  [description]
         * @param  {[type]} contrat_id [description]
         * @param  {[type]} format     [description]
         * @param  {[type]} template   [description]
         * @param  {[type]} cols       [description]
         * @param  {[type]} rows       [description]
         * @param  {[type]} extras     [description]
         * @return {[type]}            [description]
         */
        exportGrid: function (grid_name, contrat_id, format, template, cols, rows, extras) {
            return crudService.post(
                '/' + format + '/export-grid',
                {
                    template: template,
                    contrat_id: contrat_id,
                    colonnes: cols,
                    lignes: angular.toJson(rows),
                    extras: extras || {},
                    grid_name: grid_name
                }
            ).then(function (response) {
                $window.location.href = '/' + format + '/download/' + response;
            }, function (error) {
                return $q.reject(error);
            });
        },
        /**
         * Création d'un fichier JSON avec les lignes en parametres (préparation pour export consequent (poste2018))
         * @param  {[type]} grid_name  [description]
         * @param  {[type]} contrat_id [description]
         * @param  {[type]} format     [description]
         * @param  {[type]} template   [description]
         * @param  {[type]} cols       [description]
         * @param  {[type]} rows       [description]
         * @param  {[type]} extras     [description]
         * @return {[type]}            [description]
         */
        prepareExportGrid: function (grid_name, contrat_id, format, template, cols, rows, extras) {
            return crudService.post(
                '/' + format + '/prepare-export-grid',
                {
                    template: template,
                    contrat_id: contrat_id,
                    colonnes: cols,
                    lignes: angular.toJson(rows),
                    extras: extras || {},
                    grid_name: grid_name
                }
            ).then(function (response) {
                return response;
            }, function (error) {
                return $q.reject(error);
            });
        },
        /**
         * Récuperation des lignes via les fichiers JSON préparés via prepareExportGrid()
         * @param  {[type]} grid_name     [description]
         * @param  {[type]} contrat_id    [description]
         * @param  {[type]} format        [description]
         * @param  {[type]} template      [description]
         * @param  {[type]} cols          [description]
         * @param  {[type]} jsonFilePaths [description]
         * @param  {[type]} extras        [description]
         * @return {[type]}               [description]
         */
        finalizeExportGrid: function (grid_name, contrat_id, format, template, cols, jsonFilePaths, extras) {
            return crudService.post(
                '/' + format + '/finalize-export-grid',
                {
                    template: template,
                    contrat_id: contrat_id,
                    colonnes: cols,
                    json_file_paths: angular.toJson(jsonFilePaths),
                    extras: extras || {},
                    grid_name: grid_name
                }
            ).then(function (response) {
                if (angular.isDefined(response.file)) {
                    // Si un fichier est retourné
                    $window.location.href = '/' + format + '/download/' + response.file;
                } else if (angular.isDefined(response.message)) {
                    // Si un message est retourné : surement un export en background (poste2018)
                    modalService.show(
                        'info sign',
                        (angular.isDefined(response.title) ? response.title : $filter('translate')('export_en_cours')),
                        response.message
                    );

                } else {
                    // @TODO: Erreur
                    console.log("error", response);
                }
            }, function (error) {
                return $q.reject(error);
            });
        }


    }
}]);
